import { ResponseModel } from "../../models/response/responseModel";
import axios from "axios";

class EndpointFunctions {
  static handleResponse = ({ response }) => {
    if (response.data && response.data !== "") {
      const responseModel = ResponseModel.fromJson(response.data);
      const isSuccess = responseModel.success;

      if (isSuccess) {
        return { data: responseModel.data, success: true };
      } else {
        return {
          errorTitle: `Error (${responseModel.meta.httpStatusCode}) - ${responseModel.meta.errorType}`,
          errorMessage: responseModel.meta.errorMessage,
          success: false,
        };
      }
    } else {
      return {
        errorTitle: "Error",
        errorMessage: "Unknown Error",
        success: false,
      };
    }
  };

  static handleError = ({ error }) => {
    console.log("---handleError ERROR---", error);
    if (error.response && error.response.data && error.response.data !== "") {
      const responseModel = ResponseModel.fromJson(error.response.data);
      return {
        errorTitle: `Error (${responseModel.meta.httpStatusCode}) - ${responseModel.meta.errorType}`,
        errorMessage: responseModel.meta.errorMessage,
        success: false,
      };
    } else if (error instanceof axios.CanceledError) {
      return {
        errorTitle: "Cancelled",
        errorMessage: "Request cancelled",
        success: false,
      };
    } else {
      return {
        errorTitle: "Error",
        errorMessage: "Unknown Error",
        success: false,
      };
    }
  };

  static fetchData = async ({
    axiosPrivate,
    endpointURL,
    httpParams,
    controller,
  }) => {
    try {
      let response;
      if (httpParams != null) {
        response = await axiosPrivate.get(endpointURL, {
          params: httpParams,
          signal: controller?.signal,
        });
      } else {
        response = await axiosPrivate.get(endpointURL, {
          signal: controller?.signal,
        });
      }
      console.log("---RESPONSE---", response);
      return this.handleResponse({ response: response });
    } catch (error) {
      console.log("---ERROR---", error);
      return this.handleError({ error: error });
    }
  };

  static postData = async ({
    axiosPrivate,
    endpointURL,
    formData,
    requestBody,
    isMultiPart,
  }) => {
    try {
      let response;
      if (isMultiPart) {
        response = await axiosPrivate.post(endpointURL, formData, {
          multiPart: isMultiPart,
        });
      } else {
        response = await axiosPrivate.post(endpointURL, requestBody);
      }
      console.log("---RESPONSE---", response);
      return this.handleResponse({ response: response });
    } catch (error) {
      console.log("---ERROR---", error);
      return this.handleError({ error: error });
    }
  };

  static putData = async ({
    axiosPrivate,
    endpointURL,
    data,
    formData,
    params,
    isMultiPart,
  }) => {
    try {
      let response;
      if (isMultiPart) {
        response = await axiosPrivate.put(endpointURL, formData, {
          multiPart: isMultiPart,
          params: params,
        });
      } else {
        response = await axiosPrivate.put(endpointURL, data, {
          params: params,
        });
      }
      console.log("---RESPONSE---", response);
      return this.handleResponse({ response: response });
    } catch (error) {
      console.log("---ERROR---", error);
      return this.handleError({ error: error });
    }
  };

  static deleteRecord = async ({ axiosPrivate, endpointURL, recordId }) => {
    const requestBody = {
      id: recordId,
    };
    console.log("---REQUEST BODY---", requestBody);

    try {
      const response = await axiosPrivate.delete(
        `${endpointURL}/${recordId}`,
        requestBody
      );
      console.log("---RESPONSE---", response);
      return this.handleResponse({ response: response });
    } catch (error) {
      console.log("---ERROR---", error);
      return this.handleError({ error: error });
    }
  };

  static deleteData = async ({ axiosPrivate, endpointURL, requestBody }) => {
    console.log("---REQUEST BODY---", requestBody);

    try {
      const response = await axiosPrivate.delete(endpointURL, requestBody);
      console.log("---RESPONSE---", response);
      return this.handleResponse({ response: response });
    } catch (error) {
      console.log("---ERROR---", error);
      return this.handleError({ error: error });
    }
  };
}

export default EndpointFunctions;
